import moment from 'moment';

/**
 * Tempo de atendimento (CORE-2636): a data/hora do roteamento vem do histórico
 * do ticket (/accompaniments) — evento "Responsável atribuído/alterado" mais
 * recente. O cache do Redux (por actionId = ticketId) faz as vezes de memória:
 * uma vez buscado, o cronômetro persiste até o refresh da página.
 */

export function extractAssignedAt(accompaniments: any[] | null | undefined): string | null {
  // ticket re-roteado tem VÁRIOS eventos de atribuição — vale o mais recente.
  // Compara as datas em vez de confiar na ordenação da lista (a API devolve
  // desc; o loop antigo varria do fim e pegava o evento mais ANTIGO).
  let latest: string | null = null;
  (accompaniments || []).forEach((item) => {
    const title = `${item?.title || ''}`.toLowerCase();
    if (title.includes('responsável') && (title.includes('atribuído') || title.includes('alterado'))) {
      const date = item?.date;
      // formato "YYYY-MM-DD HH:mm:ss" ordena lexicograficamente
      if (date && (!latest || date > latest)) latest = date;
    }
  });
  return latest;
}

// tempo decorrido desde o roteamento, no formato HH:MM:SS
export function formatElapsed(assignedAt: string): string | null {
  const parsed = moment(assignedAt, 'YYYY-MM-DD HH:mm:ss');
  if (!parsed.isValid()) return null;
  const totalSeconds = Math.max(0, moment().diff(parsed, 'seconds'));
  const pad = (value: number) => String(value).padStart(2, '0');
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}
